import { Editor } from '@tinymce/tinymce-react';
import React, { useRef, useEffect, useState } from "react";
import './RichTextEditor.css';
import { loadTranslation } from './help/index.js';
import { Loader } from '../loader/loader.jsx';

const TINYMCE_SRC = '/tinymce/tinymce.min.js';

function loadScript(src) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
}

const RichTextEditor = ({
  value,
  onChange,
  height = 500,
  placeholder = 'Type your content here...',
  disabled = false,
  menubar = 'file edit view insert format tools table tc help',
  plugins = 'code preview importcss searchreplace autolink autosave save directionality visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help emoticons quickbars',
  toolbar = 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment',
}) => {
  const editorRef = useRef(null);
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    loadScript(TINYMCE_SRC)
      .then(() => {
        setTimeout(() => {
          setScriptLoaded(true)
        }, 500);
      })
      .catch(() => setScriptLoaded(false));
  }, []);

  // Handle editor content change
  const handleEditorChange = (content) => {
    if (onChange) {
      onChange(content);
    }
  };

  const config = {
    language: localStorage.language || 'nl',
    height,
    menubar: true,
    plugins,
    toolbar,
    placeholder,
    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
    help_tabs: [
      'shortcuts',
      'iframe_help',
      'template_tags',
    ],
    license_key: 'gpl'
  }

  function onInit(_evt, editor) {
    editorRef.current = editor
    handleTranslation(editor)
  }

  async function handleTranslation(editor) {
    // https://www.tiny.cloud/docs/tinymce/latest/help/
    const onInit = await loadTranslation(localStorage.language || 'nl')
    onInit(editor)
  }

  if (!scriptLoaded) {
    return <Loader />;
  }

  return (
    <Editor
      tinymceScriptSrc={TINYMCE_SRC}
      initialValue={value}
      onEditorChange={handleEditorChange}
      onInit={onInit}
      init={config}
    />
  );
};

export default RichTextEditor;